export default __webpack_public_path__ + "static/6-08bbab205890aa7e844577f5c8961a39.png";